import { BasicInfo, Language, UserProfile } from '@brands/services/identity/types/UserProfile';
import { UpdateMe } from '@brands/services/identity/updateMe';
import { parsePhoneNumber } from 'libphonenumber-js';

export function hasMeChanged(currentUser: UserProfile, newData: UpdateMe): boolean {
  const current = currentUser;

  const normalizePhone = (phone?: string) => (phone ? (parsePhoneNumber(phone, 'US')?.format('E.164') ?? '') : '');

  const phoneChanged = normalizePhone(current.phone_number) !== normalizePhone(newData.phone_number as string);

  const addressChanged =
    current.address?.address1 !== newData.address?.address1 ||
    current.address?.address2 !== newData.address?.address2 ||
    current.address?.city !== newData.address?.city ||
    current.address?.state !== newData.address?.state ||
    current.address?.zip_code !== newData.address?.zip_code;

  return phoneChanged || addressChanged;
}

export function hasBasicInfoChanged(currentUser: UserProfile, newData: BasicInfo): boolean {
  const basic = currentUser.basic_info;

  const normalizeLanguages = (langs: Language[] | string[] = []) =>
    langs.map((lang: any) => (typeof lang === 'string' ? lang : lang.id?.toString())).sort();

  const currentLanguages = normalizeLanguages(basic?.languages || []);
  const newLanguages = normalizeLanguages(newData.languages || []);

  // Forms without a middle name field leave it undefined, so they can't have changed it.
  const middleNameChanged = newData.middle_name !== undefined && (basic?.middle_name || '') !== newData.middle_name;

  return basic?.first_name !== newData.first_name || basic?.last_name !== newData.last_name || middleNameChanged;
}
